@use "../../../../../styles/Constants.scss" as Constants;
@use "../../../../../styles/Colors.scss" as Colors;

.email-list {
	display: flex;
	justify-content: flex-start;
	align-items: center;
	flex-wrap: wrap;
	margin-top: Constants.$val-spacing-m;
	margin-left: Constants.$val-spacing-l;
	margin-right: Constants.$val-spacing-s;
	padding-bottom: Constants.$val-spacing-s;

	&__create-email {
		margin-top: Constants.$val-spacing-s;
		margin-bottom: Constants.$val-spacing-s;
		margin-left: Constants.$val-spacing-l;
	}
}

.email-input-container {
	display: flex;
	align-items: center;
	margin-right: Constants.$val-spacing-s;
	margin-bottom: Constants.$val-spacing-xs;
	height: Constants.$val-fieldSize;
	width: fit-content;
}